import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Landscape } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { SM_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { IconWrapper, IconWrapperContainer } from './styled';
export const FlipToLandscapeModal = () => {
    const isRightToLeft = useSelector(getRTL);
    const { title, content, primaryButtonContent } = useSelector(getModalData);
    const dispatch = useDispatch();
    const handleHideModal = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    return (React.createElement(StaticModalWindow, { onHide: handleHideModal, minHeight: "auto", staticModalSize: SM_MODAL, title: title, isRightToLeft: isRightToLeft, footerComponent: React.createElement(ModalWindowFooter, { isSubmitButton: true, isSubmitButtonFullWidth: true, submitButtonLabel: primaryButtonContent, onSubmit: handleHideModal }) },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapperContainer, null,
                React.createElement(IconWrapper, null,
                    React.createElement(SVGIcon, { type: Landscape, size: ICON_SIZE.s })))),
        typeof content === 'string' ? (React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, content)) : (content)));
};
